import { axiosInstance } from './axios';

const VAPID_PUBLIC_KEY = 'BCscnar-FhNAhuotktHPIf8xMF3jP3ev09lkNpoRXc-OnfUFg_N6mAqW8KPkII3h7bj5Nr0m6F-jZIPGmZPErl0';

export async function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      console.log('Service Worker registrado:', registration);
      
      registration.update();
      
      return registration;
    } catch (error) {
      console.error('Error al registrar Service Worker:', error);
      throw error;
    }
  }
  throw new Error('Service Workers no soportados');
}

export async function requestPushPermission(): Promise<boolean> {
  const permission = await Notification.requestPermission();
  return permission === 'granted';
}

export async function getPushSubscription(registration: ServiceWorkerRegistration): Promise<PushSubscription | null> {
  let subscription = await registration.pushManager.getSubscription();
  
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
    });
  }
  
  return subscription;
}

export async function subscribeToPush(): Promise<PushSubscription | null> {
  try {
    const registration = await registerServiceWorker();
    const hasPermission = await requestPushPermission();
    
    if (!hasPermission) {
      console.warn('Permiso de notificaciones denegado');
      return null;
    }
    
    const subscription = await getPushSubscription(registration);
    return subscription;
  } catch (error) {
    console.error('Error en suscripción push:', error);
    return null;
  }
}

export async function sendSubscriptionToBackend(subscription: PushSubscription) {
  const res = await axiosInstance.post('/push/subscribe', subscription);
  return res.data;
}

export async function checkExistingSubscription(): Promise<boolean> {
  try {
    if (Notification.permission !== 'granted') {
      return false;
    }
    
    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration) return false;
    
    const subscription = await registration.pushManager.getSubscription();
    return !!subscription;
  } catch {
    return false;
  }
}

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  
  return outputArray;
}
